import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { EMAIL_CONFIRM_NAV_FLAG } from '../constants/authRedirect';
import { supabase } from '../lib/supabase';

/**
 * Supabase confirms email via Site URL (`/`) + hash (? tokens) unless `redirect_to` is allowlisted exactly.
 * After session is hydrated, send users to `/login` with `?confirmed=1` for the onboarding message.
 */
export function EmailConfirmRedirect() {
  const navigate = useNavigate();
  const wentRef = useRef(false);

  useEffect(() => {
    if (!sessionStorage.getItem(EMAIL_CONFIRM_NAV_FLAG)) return;

    const go = () => {
      if (wentRef.current || !sessionStorage.getItem(EMAIL_CONFIRM_NAV_FLAG)) return;
      wentRef.current = true;
      sessionStorage.removeItem(EMAIL_CONFIRM_NAV_FLAG);
      navigate('/login?confirmed=1', { replace: true });
    };

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if ((event === 'INITIAL_SESSION' || event === 'SIGNED_IN') && session) go();
    });

    void supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) go();
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return null;
}
